import React from "react"
import PropTypes from "prop-types"
import { Box, Button, Center, Image, Text } from "@chakra-ui/react"
import MessageConfirmationIcon from "../../images/contact/contact-msg-icon.png"

const styles = {
  button: {
    bg: "#129459",
    color: "white",
    fontWeight: "md",
    display: "block",
    "&:hover,&:active,&:focus": {
      bg: "#129459",
      outline: "none",
      border: "none",
    },
  },
  box: {
    width: { base: "100%", md: "100%", lg: "607px" },
    px: { base: "24px", md: "24px", lg: "0px" },
    borderRadius: "0.4em",
    margin: "2em 0",
    boxShadow: "0.2em 0.25em 0.4em grey;",
    bg: "white",
  },
  container: {
    padding: "0.25em",
    margin: "0.3em",
  },
}

const MessageConfirmation = ({ onClose, message, closeText }) => {
  return (
    <Center>
      <Box sx={styles.box}>
        <Box
          sx={{
            marginBottom: "2em",
            borderBottom: "1px solid lightgrey",
            p: 5,
          }}
        >
          <Text sx={{ fontWeight: "bold", fontSize: "lg" }}>Message Sent!</Text>
        </Box>
        <Center>
          <Image
            alt="Message sent logo"
            boxSize="85px"
            marginBottom="1em"
            borderRadius=".75em"
            src={MessageConfirmationIcon}
          ></Image>
        </Center>
        <Box
          dangerouslySetInnerHTML={{ __html: message }}
          sx={{
            "> p": {
              color: "grey",
              fontSize: "sm",
              textAlign: "center",
              marginBottom: "2em",
              mx: "2em",
            },
          }}
        />

        <Box sx={{ marginTop: "3em", borderTop: "1px solid lightgrey", p: 5 }}>
          <Button onClick={onClose} sx={styles.button}>
            {closeText}
          </Button>
        </Box>
      </Box>
    </Center>
  )
}

MessageConfirmation.propTypes = {
  onClose: PropTypes.func,
  message: PropTypes.string,
  closeText: PropTypes.string,
}

MessageConfirmation.defaultProps = {
  onClose: () => {},
  message:
    "<p>Thanks for your message. We will be in touch as soon as possible.</p>",
  closeText: "Back to home page",
}

export default MessageConfirmation
